import React from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import shouldLoadDyna from '@/bit/core/core.utils.should-load-dyna';
import RouteHandler from '@/bit/core/core.route-handler';
import Saam from '@/bit/core/core.scripts.saam';
import OneTrust from '@/bit/components/components.one-trust-x';
import ErrorBoundary from '@/component/error-boundary';
import { wrapper } from 'store';
import '@/styles/globals.scss';
import '@/styles/skeleton.scss';
// IMPORTS

 /* [STYLES] begins */ 
 import '@/styles/globals.scss'; 
 import '@/styles/grid.scss'; 
 import '@/styles/colors.scss'; 
 import '@/styles/fonts.scss';
 
 /* [STYLES] ends */ 


const Dyna = dynamic(() => import('@/bit/core/core.scripts.dyna'));

const App = ({ Component, pageProps }) => {
  const Modal = useSelector((state) => state.modals.Modal);
  return (
    <>
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        {Modal && Modal}
        <OneTrust />
      </ErrorBoundary>
      <Saam />
      {shouldLoadDyna() && <Dyna />}
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
